<div class="container personal-data-container mt-5" >
    <div class="pb-3 col-6 col-sm-4 col-md-3 col-lg-2 d-flex justify-content-center">
        <a routerLink="/contratos" class="btn btn-primary d-block volver"> <fa-icon [icon]="faChevronLeft"></fa-icon> VOLVER</a>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-12 col-sm-11 col-10">
            <h2 class="text-center mt-3 mb-4">DETALLES contrato Nº <span *ngIf="contractData">{{contractData.numeroContrato}}</span></h2>
            <div class="border-table">
                <div class="content-table">
                    <ng-container *ngIf="contractData">
                        <div class="row align-items-center">
                            <div class="col-md-3">Número de contrato</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.numeroContrato}}</div>
                            <div class="col-md-3">Fecha de alta del contrato</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.fechaNominalCreacion | date: "dd/MM/yyyy"}}</div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-3">Duración del contrato</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.termAsText}}</div>
                            <div class="col-md-3">Fecha de Vencimiento del Contrato</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.fechaVencimiento | date: "dd/MM/yyyy"}}</div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-3">Peso total</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.pesoOroNeto}} g</div>
                            <div class="col-md-3">Peso en oro</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.pesoOro}} g</div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                Descripción
                            </div>
                            <div class="col-md-3 font-weight-bold font-small-bold">
                                {{contractData.descripcion}}
                            </div>
                            <div class="col-md-3">Importe del Contrato</div>
                            <div class="col-md-3 font-weight-bold">{{contractData.importeContrato}}€</div>
                        </div>
                        <div class="row justify-content-center bg-hover-transparent">
                            <div class="col-lg-10">
                                <div class="row bg-hover-transparent" [ngClass]="{'justify-content-start' : contractData.vigente === false || limitRenovation}">
                                    <!-- If no limit of renovations reached -->
                                    <div class="col-md-6 mb-md-0 mb-4" *ngIf="!limitRenovation"> 
                                        <a (click)="downloadContractPdf(contractData.codContrato, contractData.numeroContrato)" class="btn btn-primary d-block btn-download"><i class="fas fa-file-download"></i> DESCARGAR en pdf</a>
                                    </div>
                                    <div class="col-md-6" *ngIf="contractData.vigente && !limitRenovation">
                                        <a (click)="requestContractRenewal()" class="btn btn-primary d-block  btn-renewal "><i class="fas fa-sync-alt"></i> RENOVAR</a>
                                    </div>
                                    <!-- If limit of renovations reached -->
                                    <div class="col-md-12 mb-md-0 mb-4" *ngIf="limitRenovation"> 
                                        <a (click)="downloadContractPdf(contractData.codContrato, contractData.numeroContrato)" class="btn btn-primary d-block btn-download"><i class="fas fa-file-download"></i> DESCARGAR en pdf</a>
                                    </div>
                                    <div class="col-12 text-center font-weight-bold mt-3" *ngIf="contractData.vigente && limitRenovation">
                                        {{ limitRenovationWarning }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <p class="text-center font-weight-bold mt-3" *ngIf="textMessageError">{{ textMessageError }}</p>
                    <app-loader *ngIf="showLoader"></app-loader>
                </div>
              
            </div>
        </div>
    </div>
</div>

<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>

<app-historic-renovation></app-historic-renovation>